import React from "react";

import { SxProps, Theme } from "@mui/system";
import { styled } from "@mui/material/styles";

// mui components
import Typography from "../mui/Typography";
import Button from "../mui/Button";
import Stack from "../mui/Stack";
import Grid from "../mui/Grid";
import Chip from "../mui/Chip";
import Box from "../mui/Box";

// common components
import MagicLoadingBox from "./MagicLoadingBox";

interface BtnInterface {
  text: string;
  variant?: "text" | "outlined" | "contained" | any;

  disabled?: boolean;

  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  loading?: boolean;

  sx?: SxProps<Theme>;
  onClick: () => void;
}

interface HeaderProps {
  title?: any;
  subTitle?: string;
  isLoading?: boolean;
  chipLabel: string | number;
  buttons?: BtnInterface[] | any;

  titleSx?: SxProps<Theme>;
  subTitleSx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
}

const MagicPageHeader: React.FC<HeaderProps> = (props) => {
  const {
    title,
    subTitle,
    chipLabel,
    isLoading,
    buttons = [],
    titleSx = {},
    subTitleSx = {},
    sx,
  } = props;

  // handle loading stats of data
  if (isLoading) return <MagicLoadingBox height={100}/>


  return (
    <Grid container spacing={0} sx={{ mb: 2, ...sx }}>
      {/* this Grid contain only Title, chip, and subTitle */}
      <Grid item xs={6}>
        {/* Title */}
        <Stack direction="row" alignItems="center" mb={1}>
          <Title sx={{ ...titleSx }}>{title}</Title>
          {chipLabel && <StyledChip size="small" label={chipLabel} />}
        </Stack>

        {/* Sub Title */}
        <SubTitle sx={{ ...subTitleSx }}>{subTitle}</SubTitle>
      </Grid>

      {/* this contain only Buttons */}
      <Grid item xs={6} alignItems={"center"} display={"flex"}>
        <StyledBox>
          {buttons.map(
            (btn: BtnInterface, index: number) =>
              btn.text && (
                <Button
                  key={index}
                  variant={btn.variant}
                  startIcon={btn.startIcon}
                  endIcon={btn.endIcon}
                  onClick={btn.onClick}
                  disabled={btn.disabled}
                  sx={{ textTransform: "capitalize",...(btn.sx || {}) }}
                  loading={btn.loading}
                >
                  {btn.text}
                </Button>
              )
          )}
        </StyledBox>
      </Grid>
    </Grid>
  );
};

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "20px",
  color: "rgb(16, 24, 41)",
  lineHeight: "1",
}));

const SubTitle = styled(Typography)(({ theme }) => ({
  fontSize: "15px",
  fontWeight: 400,
  color: "#667085",
}));

const StyledChip = styled(Chip)(({ theme }) => ({
  marginLeft: "15px",
  textTransform: "capitalize",
  backgroundColor: "rgb(255, 244, 199)",
  color: "#242424",
  fontWeight: 500,
}));

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
  gap: "10px",
}));

export default MagicPageHeader;
